module.exports = __webpack_public_path__ + "img/ch16_18_难题墙解题.7ec4c8ed.jpg";